import { appRoutes } from 'features/app/routes/paths';

export const redemptionsPaths = Object.freeze({
  static: {
    root: `${appRoutes.static.root}/redemptions`,
  },
});
